// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1kTbT","requiredAsterisk":"Info_requiredAsterisk__1PCC2"};